import type { DeviceNotificationPermission } from '@Domain/Ports/Notification/DeviceNotificationPort';

/**
 * Translates a browser `NotificationPermission` into the domain's `DeviceNotificationPermission`.
 * The domain type carries one value more than this function ever produces: the caller's own verdict
 * for the case where the browser lacks the capability entirely, which this function never observes.
 */
const mapBrowserPermission = (permission: NotificationPermission): DeviceNotificationPermission => {
	if (permission === 'granted') {
		return 'granted';
	}
	if (permission === 'denied') {
		return 'denied';
	}
	return 'prompt';
};

export default mapBrowserPermission;
